import React, { useEffect, useState } from 'react';
import { Layout, Breadcrumb, Menu, Card, Skeleton,Typography,Image } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { UnorderedListOutlined,DownloadOutlined,VideoCameraOutlined } from "@ant-design/icons";
import * as AntIcons from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

interface HelpDetailsData{
    helpDetailsId:string;
    helpCategoryId:string;
    helpCategoryName:string;
    shortDescription: string;
    description: string;
    documentDescription: string;
    documentName: string;
    mediaDescription: string;
    mediaName: string;
    createdDate:Date;
    createdName:string;
}

interface HelpCategory {
    helpCategoryId:string;
    helpCategoryName:string;
    helpCategoryDescription: string;
    helpCategoryIcon: string;
    isActive:string;
    createdDate:boolean;
    createdBy:string;
    updatedDate:string;
    updatedBy:string;
}

const HelpDetailsPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [helpDetails, setHelpDetailsData] = useState<HelpDetailsData>();
  const [helpCategoryData, setHelpCategoryData] = useState<HelpCategory[]>([]);
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { helpCategoryId } = location.state || {};
  const { Sider, Content } = Layout;

  const fetchToken = async () => {
      const res = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0]
      });
      return res.idToken;
    };

 
    useEffect(() => {
      fetchToken();
      getHelpDetailsData();
      getHelpCategoryData();
    }, []);

    const getHelpDetailsData = async () => {
    if (loading) return;
      try {
        setLoading(true);
        const token = await fetchToken();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/HelpDetails/GetHelpDetailsByCategoryId/${helpCategoryId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
        if (response.status === 200) {
            setHelpDetailsData(response.data);
        }
        else{
            setHelpDetailsData(undefined);
        }
      }
      catch (error) {
        console.error('Error while getting help category data:', error);
      }
      finally {
        setLoading(false);
      }
    };

    const getHelpCategoryData = async () => {
    if (loading) return;
      try {
        setLoading(true);
        const token = await fetchToken();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/HelpCategory/GetHelpCategoryByHelpData/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
        if (response.status === 200) {
            setHelpCategoryData(response.data);
        }
        else{
            setHelpCategoryData([]);
        }
      }
      catch (error) {
        console.error('Error while getting help category data:', error);
      }
      finally {
        setLoading(false);
      }
    };

    // Helper function to get icon component by name
        const getIconComponent = (iconName: string) => {
        const Icon = (AntIcons as any)[iconName];
        return Icon ? <Icon style={{ color: '#ffffff', fontSize: 16 }} /> : <AntIcons.QuestionOutlined style={{ color: '#ffffff', fontSize: 16 }} />;
        };

    const handleCardClick = (helpCategoryId: string) => {
        navigate('/viewhelpdetails', { state: { helpCategoryId: helpCategoryId } });
    };

    return (
        <Layout style={{ background: '#F9FAFB' }}>
          <AppHeaderHomePageTemplate />
          <div style={{ 
            maxWidth: '100%', 
            margin: '0 auto', 
            padding: '0px',
            backgroundColor: '#',
            minHeight: '100vh',
            width: '62rem'
            }}>
      
        <Breadcrumb 
            style={{ 
                backgroundColor: 'white',
                padding: '20px 20px 10px',
            }}
            >
            <Breadcrumb.Item>
                <Link to="/home">
                <HomeOutlined style={{ marginRight: '5px' }} />
                    {t('home')}
                </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/helpdata">
                    {t('help')}
                </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                {helpDetails?.helpCategoryName}
            </Breadcrumb.Item>
        </Breadcrumb>
        <div style={{ 
            backgroundColor: 'white',
            padding: '0px 20px', fontWeight: '600', font:'roboto', fontSize: '22px', color: '#000000'
        }}>
            {helpDetails?.helpCategoryName}
        </div>
        <div style={{ 
            backgroundColor: 'white',
            padding: '5px 20px', fontWeight: '400', font:'roboto', fontSize: '14px',color: '#000000'
        }}>
            {helpDetails?.shortDescription}
        </div>
        
        {/* Help Details */}
        <div>
            <Layout style={{ background: "#fff"}}>
            <Sider width={230} style={{ background: "#fff", padding: "16px" }}>
                <Title style={{ marginTop: 0, fontSize:"16px",fontWeight:600 }}><UnorderedListOutlined /> In this article</Title>
                <Menu mode="inline" style={{ padding: 0, margin: 0,background: "transparent" }}>
                        {helpDetails?.documentDescription && (
                            <Menu.Item
                            key={1}
                            style={{
                                color: "#1677FF",
                                fontWeight: 400,
                                margin: 0,
                                lineHeight: "22px",
                                padding: 0,
                            }}
                            >
                            <a
                                href={`help/${helpDetails?.documentName}`} target='_blank'
                                title='Download Document'
                                style={{ color: "#1677FF", textDecoration: "none" }}
                                rel="noopener noreferrer"
                            >
                                {helpDetails?.documentDescription} <DownloadOutlined style={{ fontSize: 16 }} />
                            </a>
                            </Menu.Item>
                        )}
                        {helpDetails?.mediaDescription && (
                        <Menu.Item
                        key={2}
                        style={{
                            color: "#1677FF",
                            fontWeight: 400,
                            margin: 0,
                            lineHeight: "22px",
                            padding: 0,
                        }}
                        >
                            <a
                                href={`help/${helpDetails?.mediaName}`} target='_blank'
                                title='Download Video'
                                style={{ color: "#1677FF", textDecoration: "none" }}
                                rel="noopener noreferrer"
                            >
                                {helpDetails?.mediaDescription} <VideoCameraOutlined style={{  fontSize: 16 }} />
                            </a>
                        
                        </Menu.Item>
                    )}
                </Menu>
            </Sider>

            <Layout style={{ background: "#fff", marginBottom:"15px" }}>
                <Content style={{ marginRight:"10px" }}>
                <Card bodyStyle={{ padding: 10 }}>
                    <div>
                        {helpDetails?.description && (
                            <span dangerouslySetInnerHTML={{ __html: helpDetails.description }} />
                        )}
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        {helpDetails?.mediaName ? (
                            <video width="100%" controls>
                                <source src={`help/${helpDetails.mediaName}`} type="video/mp4" />
                                    Your browser does not support the video tag.
                            </video>
                        ) : null}
                    </div>
                </Card>
                </Content>
            </Layout>
            </Layout>
        </div>
    </div>

        </Layout>
    
      );
    };

export default HelpDetailsPage;